<template>
  <div>登录资源加载中.</div>
</template>

<script>
// import mgr from "@/oidc";
import { mapActions } from 'vuex'

export default {
  name: 'OidcCallback',
  // created() {
  //   // mgr.signinRedirectCallback().then(
  //   //   // (u) => {
  //   //   //   console.log(u);
  //   //   //   window.history.replaceState(
  //   //   //     {},
  //   //   //     window.document.title,
  //   //   //     window.location.origin + window.location.pathname
  //   //   //   );
  //   //   //   window.location = "/";
  //   //   // },
  //   //   // (error) => {
  //   //   //   console.log(error);
  //   //   // }
  //   //   () => {
  //   //     mgr.getUser().then((user) => {
  //   //       if (window.localStorage) {
  //   //         window.localStorage.setItem("userInfo", JSON.stringify(user.profile));
  //   //         window.localStorage.setItem("token", user.access_token);
  //   //         //window.close()
  //   //       }
  //   //       //this.$router.push("/");
  //   //     });
  //   //   }
  //   // );
  // },
  mounted() {
    this.oidcSignInPopupCallback()
      .then((redirectPath) => {
        this.$router.push(redirectPath).catch(()=>{});
      })
      .catch((err) => {
        console.error(err)
        // this.$router.push('/oidc-callback-error') // Handle errors any way you want
      })
  },
  methods: {
    ...mapActions('oidc', [
      'oidcSignInCallback',
      'oidcSignInPopupCallback',
      'removeOidcUser'
    ])
  },
  render: function(h) {
    return h() // avoid warning message
  }
}
</script>
